'use strict'

export default (mockAxios) => {
  // 名刺情報の作成
  mockAxios.onPost(`/bcard-entries`).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'sid_person': 1
    }
  })

  // CSVファイルからの登録状況一覧
  mockAxios.onGet(`/bcard-csvs`).reply(200, {
    'success': true,
    'data': [
      {
        'id': '000000011_20191030115615',
        'formatted_uploadtime': '2018/01/01 00:00:00',
        'status': '0',
        'lang_status': '登録完了',
        'filename': 'example.csv',
        'datacnt': 25,
        'updatecnt': 0,
        'update_data': 0,
        'msgdetail': '登録可能な名刺件数の上限に達しました。',
        'isChecking': false,
        'isCheckError': false,
        'isRegisting': false,
        'isRegistError': false,
        'isSysError': false,
        'isCompleted': true
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 名刺情報のCSVファイルをアップロード
  mockAxios.onPost(`/bcard-csvs`).reply(200, {
    'success': true,
    'data': {
      'id': 1
    }
  })

  // CSVアップロードの処理結果を取得
  mockAxios.onGet(`/bcard-csvs/upload-result`).reply(200, {
    'success': true,
    'result': 'success',
    'status': 'finish'
  })

  // 検索
  mockAxios.onPost(`/bcards`).reply(200, {
    'success': true,
    'data': [
      {
        'sid_person': 1,
        'id': 1,
        'openflag': '1',
        'corporate_name': '株式会社RRRコンピューターサービス',
        'dept': '公共情報事業本部',
        'post': '主任心得',
        'o1_tel1': '0330-88-1590',
        'o1_mobile': '090-1122-3344',
        'o1_fax': '0330-88-1591',
        'o1_mail': 'fukuda@exa.com',
        'o1_zipcode': '100-1234',
        'o1_address1': '東京都品川区西大井1-1-2',
        'o1_address2': '八木ビル5F',
        'person': {
          'openflag': '1'
        },
        'isFavorite': '0',
        'tags': [
          {
            'id': 1,
            'name': 'サンプルタグ',
            'openflag': '1',
            'seqno': 1,
            'color_rgb': '#ffecb3'
          }
        ],
        'is_latest': '1',
        'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t',
        'exchanges': [
          {
            'sid_bcard': 1,
            'id': 4,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '山田 太郎'
            },
            'formatted_exdate': '2020/12/21'
          },
          {
            'sid_bcard': 1,
            'id': 3,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '佐々木 小次郎'
            },
            'formatted_exdate': '2020/12/21'
          }
        ],
        'full_name': '大森 圭介',
        'formatted_exdate': '2018/01/01'
      },
      {
        'sid_person': 2,
        'id': 2,
        'openflag': '1',
        'corporate_name': '日本カミカゼ（株）',
        'dept': '経理部',
        'post': '',
        'o1_tel1': '0248-98-6070',
        'o1_mobile': '090-1122-3344',
        'o1_fax': '0248-98-6071',
        'o1_mail': 'oomori@web.ad.jp',
        'o1_zipcode': '100-1234',
        'o1_address1': '福井県丹生郡越前町梅浦9-7-2',
        'o1_address2': 'メゾン梅浦 703',
        'person': {
          'openflag': '0'
        },
        'isFavorite': '0',
        'tags': [
          {
            'id': 1,
            'name': 'サンプルタグ',
            'openflag': '1',
            'seqno': 1,
            'color_rgb': '#ffecb3'
          }
        ],
        'is_latest': '1',
        'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t',
        'exchanges': [
          {
            'sid_bcard': 2,
            'id': 24,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '山田 太郎'
            },
            'formatted_exdate': '2020/12/21'
          },
          {
            'sid_bcard': 1,
            'id': 23,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '佐々木 小次郎'
            },
            'formatted_exdate': '2020/12/21'
          }
        ],
        'full_name': '入江 昌光',
        'formatted_exdate': '2018/01/01'
      },
      {
        'sid_person': 3,
        'id': 3,
        'openflag': '1',
        'corporate_name': '株式会社RRRコンピューターサービス',
        'dept': '営業部',
        'post': '課長',
        'o1_tel1': '0330-88-1590',
        'o1_mobile': '',
        'o1_fax': '0330-88-1591',
        'o1_mail': '',
        'o1_zipcode': '100-1234',
        'o1_address1': '東京都品川区西大井1-1-2',
        'o1_address2': '八木ビル5F',
        'person': {
          'openflag': '1'
        },
        'isFavorite': '1',
        'tags': [
        ],
        'is_latest': '1',
        'image_url': '',
        'exchanges': [
          {
            'sid_bcard': 3,
            'id': 34,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '山田 太郎'
            },
            'formatted_exdate': '2020/12/21'
          }
        ],
        'full_name': '福田 典生',
        'formatted_exdate': '2018/01/01'
      },
      {
        'sid_person': 4,
        'id': 4,
        'openflag': '0',
        'corporate_name': '株式会社日本',
        'dept': '総務部',
        'post': '',
        'o1_tel1': '',
        'o1_mobile': '',
        'o1_fax': '03-3077-1887',
        'o1_mail': 'matsu@hi-ho.ne.jp',
        'o1_zipcode': '100-1234',
        'o1_address1': '東京都品川区大井2-3-8',
        'o1_address2': '',
        'person': {
          'openflag': '1'
        },
        'isFavorite': '1',
        'tags': [
          {
            'id': 1,
            'name': 'サンプルタグ',
            'openflag': '1',
            'seqno': 1,
            'color_rgb': '#ffecb3'
          }
        ],
        'is_latest': '1',
        'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t',
        'exchanges': [
          {
            'sid_bcard': 4,
            'id': 44,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '山田 太郎'
            },
            'formatted_exdate': '2020/12/21'
          }
        ],
        'full_name': '松崎 唯',
        'formatted_exdate': '2018/01/01'
      },
      {
        'sid_person': 5,
        'id': 5,
        'openflag': '1',
        'corporate_name': 'ヨコミネコーポレーション',
        'dept': '開発部',
        'post': '',
        'o1_tel1': '0832-53-1860',
        'o1_mobile': '',
        'o1_fax': '',
        'o1_mail': 'gns1985combzmail@combzmail.jp',
        'o1_zipcode': '',
        'o1_address1': '山口県下関市一の宮東町9720',
        'o1_address2': '',
        'person': {
          'openflag': '1'
        },
        'isFavorite': '1',
        'tags': [
          {
            'id': 1,
            'name': 'サンプルタグ',
            'openflag': '1',
            'seqno': 1,
            'color_rgb': '#ffecb3'
          }
        ],
        'is_latest': '1',
        'image_url': '//localhost:8765/files/bimage/01k20094169p8y3t',
        'exchanges': [
          {
            'sid_bcard': 1,
            'id': 4,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '山田 太郎'
            },
            'formatted_exdate': '2020/12/21'
          },
          {
            'sid_bcard': 1,
            'id': 3,
            'sid_user': 2,
            'exchanger': {
              'sid_user': 2,
              'full_name': '佐々木 小次郎'
            },
            'formatted_exdate': '2020/12/21'
          }
        ],
        'full_name': '石川 栄理子',
        'formatted_exdate': '2018/01/01'
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  mockAxios.onGet(new RegExp(`/bcards/\\d+/?$`)).reply(200, {
    'success': true,
    'data': {
      'sid_person': 1,
      'id': 1
    }
  })

  // 名刺情報更新
  mockAxios.onPost(new RegExp(`/bcards/\\d+/?$`)).reply(200, {
    'success': true,
    'data': {
      'edited_id': 1
    }
  })

  // 画像からの登録状況一覧
  // mockAxios.onGet(new RegExp(`/bcard-images/top || /bcard-images`)).reply(200, {
  mockAxios.onGet(new RegExp(`/bcard-images($|¥/top$)`)).reply(200, {
    'success': true,
    'data': [
      {
        'terminal': '1',
        'lang_terminal': 'Web',
        'formatted_uploadtime': '2018/01/01 00:00:00',
        'status': '4',
        'lang_status': '修正サービス依頼中',
        'prog_status': '2/3',
        'sid_person': 1,
        'id': 1,
        'image_id': '01k20094169p8y3t',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
        'dispname': 'example.jpg',
        'formatted_exdate': '2018/01/01',
        'openflag': '1',
        'lang_openflag': '公開',
        'input_proxy': '1',
        'lang_input_proxy': '利用する',
        'exchange_date': '2018/01/01'
      },
      {
        'terminal': '1',
        'lang_terminal': 'Web',
        'formatted_uploadtime': '2018/05/01 00:00:00',
        'status': '7',
        'lang_status': '読取不能',
        'prog_status': '3/3',
        'sid_person': 1,
        'id': 2,
        'image_id': '01k20094169p8y3t',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t',
        'dispname': 'example.jpg',
        'formatted_exdate': '2018/01/01',
        'openflag': '1',
        'lang_openflag': '公開',
        'input_proxy': '1',
        'lang_input_proxy': '利用する',
        'exchange_date': '2018/01/01'
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 名刺画像情報を取得します。
  mockAxios.onGet(new RegExp(`/bcards/\\d+/images`)).reply(200, {
    'success': true,
    'data': [
      {
        'sid_attach': '01k400h4168zc9ct',
        'name': '1.jpg',
        'seqno': 1,
        'isMain': '0',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t'
      },
      {
        'sid_attach': '01k400h510w7txsh',
        'name': 'image_20200617132812.png',
        'seqno': 2,
        'isMain': '1',
        'image_url': 'http://localhost:8765/files/bimage/01k20094169p8y3t'
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 参照履歴登録
  mockAxios.onPut(new RegExp(`/bcards/\\d+/history`)).reply(201, {
    'success': true,
    'data': []
  })

  mockAxios.onPut(new RegExp(`/bcards/\\d+/new`)).reply(201, {
    'success': true,
    'data': []
  })

  mockAxios.onPost(`/bcards/export`).reply(200, {
    'success': true
  })

  mockAxios.onGet(`/bcards/export`).reply(200, {
  })

  mockAxios.onGet(`/bcards/export-result`).reply(200, {
    'success': true,
    'result': 'success',
    'status': 'finish'
  })

  mockAxios.onPost(`/bcards/export-cancel`).reply(200, {
    'success': true
  })

  mockAxios.onPost(`/bcards/tags`).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onPost(`/bcards/bulk`).reply(200, {
    'success': true
  })

  mockAxios.onPost(`/bcards/delete`).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/bcardRepositoryMock.js